import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererDefect',
  template: `
    <button mat-mini-fab color="primary" (click)="onClick($event)" *ngIf="(params.node.data.statusName!=='Closed' && params.node.data.statusName!=='Completed')"  tooltipPosition="top"  [title]="t('EditDefect', 'Edit Defect')">
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="(params.node.data.statusName==='Closed' || params.node.data.totalDefectActions>0) ? false: true" tooltipPosition="top"  [title]="t('DeleteDefect', 'Delete Defect')"
      mat-mini-fab
      color="warn"
      [disabled]="clicked"
      (click)="onClick($event)"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button *ngIf="(params.node.data.statusName!=='Closed' && params.node.data.statusName!=='Completed')" tooltipPosition="top"  [title]="t('AddAction', 'Add Action')"
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
      class="add-icon"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button *ngIf="(params.node.data.statusName ==='Closed' || params.node.data.totalDefectActions>0) ? false: true" tooltipPosition="top"  [title]="t('CloseDefect', 'Close Defect')"
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
    <button *ngIf="params.node.data.statusName ==='Closed' && params.node.data.totalDefectActions === 0" tooltipPosition="top"  [title]="t('ViewActions', 'View Actions')"
      mat-mini-fab
      color="accent"
      (click)="onClick($event)"
    >
      <mat-icon>remove_red_eye 2 </mat-icon>
    </button>
    <button style="background-color: #7a1dcf;"  [title]="t('ViewImage', 'View Image')"
      mat-mini-fab
      (click)="onClick($event)"
      *ngIf="params.node.data.statusName ==='Closed' ? false: true"
    >
    <mat-icon> insert_drive_file</mat-icon>
    </button>
    <button style="background-color: #6FBABA;"  [title]="t('ViewActions', 'View Actions')"
      mat-mini-fab tooltipPosition="top"
      *ngIf="params.node.data.totalDefectActions > 0"
      (click)="onClick($event)"
    >
    <mat-icon>remove_red_eye</mat-icon>
    </button>
  `,
  styles: [
    `
      .add-icon {
        background: cornflowerblue;
      }
      button{
        height: 35px;
        width: 35px;
        display: inline-flex;
    align-items: center;
    justify-content: center;
        margin: 0 3px;

      }
      .mat-icon {
        transform: scale(0.7);
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererDefect
  implements ICellRendererAngularComp, OnDestroy {

  constructor(public translate: TranslateService) {}

  /** i18n section for the host page in assets/i18n/*.json */
  private readonly PAGE = 'DefectManagement';

  /**
   * Resolve a tooltip: the host page's langObj (flat) -> "<PAGE>.<key>" in the
   * i18n file -> the flat "<key>" for strings shared with other pages -> English.
   */
  t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    const scoped = `${this.PAGE}.${key}`;
    const scopedValue = this.translate.instant(scoped);
    if (typeof scopedValue === 'string' && scopedValue !== scoped) {
      return scopedValue;
    }
    const flatValue = this.translate.instant(key);
    if (typeof flatValue === 'string' && flatValue !== key) {
      return flatValue;
    }
    // a key naming a whole page section resolves to an object, not a string
    if (flatValue && typeof flatValue === 'object' && typeof flatValue.title === 'string') {
      return flatValue.title;
    }
    return fallback;
  }
  clicked = false;
  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    const spec = $event.target.className;
    if (
      spec !== 'Delete' &&
      spec !== 'close'
    ) {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data,
          // ...something
        };
        this.params.onClick(params);
      }
    } else {
      this.clicked = true;
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
